<template>

    <transition appear name="slide">
        <div id="visitor_popup" v-if="displayPopup">
            <div class="wrapper">
                <div class="close font-weight-bold"><button type="button" class="btn btn-default" v-on:click="displayPopup = false"><i class="fa fa-times"></i></button></div>
                <img :src="popupImage" />
            </div>
        </div>
    </transition>

</template>

<script>
    export default {
        data: {
        },
        props: {
            popupImage: String,
            displayPopup: Boolean
        },
    }
</script>